var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoomBenefit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.667 77.067L14 87.467l-6.267-72 45.6-4.8 1.334 66.4z",
    fill: "#FFBF3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2 77.2l-32.933 8.267-5.867-61.2L53.467 19.2l1.733 58z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.867 10.533l1.466 66.934 32.4 12.666L89.2 5.867l-35.333 4.666z",
    fill: "#FFBF3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.141 54.303c1.299-.52 1.841-2.217 1.211-3.789-.63-1.572-2.193-2.425-3.492-1.905-1.299.52-1.841 2.217-1.211 3.79.63 1.572 2.193 2.424 3.492 1.904z",
    fill: "#0C0A0C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.733 11.067l1.467 66L6.8 88.933",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.333 47.067c-1.6-8.667-10-8.134-13.066-5.2 3.066-2.934.266-11.334-6.8-11.067-9.2.4-8.134 14.133.133 14.4 0 0-1.467.8-1.867 1.067-4.533 2.666-6.666 7.866-2.4 14 4.267 6.266 11.2 10 6.267 15.6-1.733 2-4.533 3.066-7.067 3.6",
    stroke: "#0C0A0C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgRoomBenefit;